export const UPDATE_LAST_LIVE_TRANSLATION_LINE = 'UPDATE_LAST_LIVE_TRANSLATION_LINE';
export const ADD_LIVE_TRANSLATION_LINE = 'live-translation/ADD_LIVE_TRANSLATION_LINE';
export const CLEAR_LIVE_TRANSLATION = 'live-translation/CLEAR_LIVE_TRANSLATION';
